import React, { Component } from "react";
import SignupForm from "../forms/SignupForm";
import axios from "axios";
import { Link } from "react-router-dom";
import { Grid, Card, Message, Header, List } from "semantic-ui-react";
import { connect } from "react-redux";
import { login } from "../../actions/auth";
import GuidePage from "./GuidePage";

class SignupPage extends Component {
  state = { value: "practitioner" };
  handleChange = (e, { value }) => this.setState({ value });
  submit = async (data) => {
    let resp = await axios.post("/api/authPractitioners/signup", { data });
    if (resp) {
      this.props.login(data).then(() => this.props.history.push("/dashboard"));
    }
  };

  render() {
    // console.log(this.props.user.resp);
    return (
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={5}></Grid.Column>
        <Grid.Column
          className="logginSeparation"
          mobile={16}
          tablet={16}
          computer={6}
        >
          <Card fluid={true}>
            <Message attached>
              <Header size="medium">Registro</Header>
            </Message>

            <Card.Content>
              <SignupForm submit={this.submit} />
            </Card.Content>

            <Message attached="bottom" warning>
              <List horizontal>
                <List.Item>
                  <Link to="/forgot_password">Restablecer contraseña</Link>
                </List.Item>
              </List>
            </Message>
          </Card>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={5}>
          <GuidePage />
        </Grid.Column>
      </Grid>
    );
  }
}

// const mapStateToProps = (state) => {
//   const { user } = state;
//   return { user };
// };
export default connect(null, { login })(SignupPage);
